import { Cell, Row as ComposedRow } from "@table-library/react-table-library/table";
import React, { useContext } from "react";
import { EMPTY_OBJ } from "../../../helpers/logic/empties";
import BaseCheckbox from "../../../Input/Checkbox/components/BaseCheckbox";
import { SelectContext } from "../../contexts/SelectContext";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Row(_ref) {
  var row = _ref.row,
    onRowClick = _ref.onRowClick,
    cells = _ref.cells;
  var _useContext = useContext(SelectContext),
    selectLogic = _useContext.selectLogic,
    selectableRows = _useContext.selectableRows;
  var _ref2 = selectLogic || EMPTY_OBJ,
    fns = _ref2.fns,
    state = _ref2.state;
  var _ref3 = state || EMPTY_OBJ,
    ids = _ref3.ids;
  return /*#__PURE__*/_jsxs(ComposedRow, {
    item: row,
    onClick: onRowClick,
    children: [selectableRows && /*#__PURE__*/_jsx(Cell, {
      children: /*#__PURE__*/_jsx(BaseCheckbox, {
        disabled: false,
        checked: ids.includes(row.id),
        onCheckedChange: function onCheckedChange() {
          return fns.onToggleById(row.id);
        }
      })
    }), cells === null || cells === void 0 ? void 0 : cells.map(function (_ref4) {
      var renderCell = _ref4.renderCell,
        key = _ref4.key;
      return /*#__PURE__*/_jsx(Cell, {
        children: renderCell(row)
      }, key);
    })]
  }, row.id);
}
export default Row;